<dx-popup
    [title]="(invoiceLine.miscItem ? 'Misc ' : '') + 'Invoice Line'"
    [width]="600"
    [height]="'auto'"
    [(visible)]="visible"
    [hideOnOutsideClick]="false"
    (onHiding)="onHiding($event)"
>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="invoiceLine" validationGroup="mainValidationGroup">
        @if (!invoiceLine.miscItem) {
            <dxi-form-item [label]="{ text: 'Rental' }">
                <div *dxTemplate>
                    @if (!invoiceLine.miscItem) {
                        <dx-select-box
                            [(value)]="invoiceLine.rentalId"
                            [items]="rentals"
                            displayExpr="displayName"
                            valueExpr="id"
                            (onValueChanged)="onRentalChanged($event)"
                        ></dx-select-box>
                    }
                </div>
            </dxi-form-item>
        }
        @if (jobs) {
            <dxi-form-item [label]="{ text: 'Job' }">
                <div *dxTemplate>
                    @if (jobs) {
                        <dx-select-box [(value)]="invoiceLine.jobId" [items]="jobs" [displayExpr]="displayJob" valueExpr="id">
                            <dx-validator validationGroup="mainValidationGroup">
                                <dxi-validator-validation-rule type="required" message="Required">
                                </dxi-validator-validation-rule> </dx-validator
                        ></dx-select-box>
                    }
                </div>
            </dxi-form-item>
        }
        <dxi-form-item dataField="service"></dxi-form-item>
        <dxi-form-item dataField="rate" [editorOptions]="{ format: { type: 'currency', precision: 2 } }"> </dxi-form-item>
        <dxi-form-item dataField="weight" editorType="dxNumberBox"></dxi-form-item>
        <dxi-form-item dataField="quantity" editorType="dxNumberBox"></dxi-form-item>
        <dxi-form-item
            dataField="quickBooksProductId"
            [label]="{ text: 'Product Account' }"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: quickBooksProducts, displayExpr: 'quickBooksProductService', valueExpr: 'id' }"
        >
        </dxi-form-item>
        <dxi-form-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-form-item>
        <dxi-form-item dataField="note" editorType="dxTextArea" [editorOptions]="{ height: '125px' }"> </dxi-form-item>
    </dx-form>
  </dx-popup>
